import axios from 'axios'
import { useMutation } from 'react-query'
import { useDispatch } from 'react-redux'
import { toast } from 'react-toastify'
import { API_URL } from 'src/cms/constants/EndPoint'
import { MasterDataStore, MasterDataSyncStatusSet } from 'src/setup/redux/MasterDataOption'

/** localStorage key holding when master data last synced successfully (ISO 8601, UTC). */
export const LAST_MASTER_DATA_SYNC_KEY = 'lastMasterDataSync'

const postMasterData = async () => {
  try {
    const response = await axios.get(`${API_URL}/master-data?table=${'all'}`)
    return response?.data
  } catch (error: any) {
     throw new Error(`${error?.response?.data?.message}`)
  }
}

const useGetMasterDataStore = () => {
  const dispatch = useDispatch()

  return useMutation(() => postMasterData(), {
    onMutate: () => {
      dispatch(MasterDataSyncStatusSet('syncing'))
    },
    onSuccess: (response: any) => {
      dispatch(MasterDataStore(response?.data))
      // Only stamp a sync that actually delivered data (MasterDataStore clears
      // the cache on an empty payload).
      if (response?.data !== undefined && response?.data !== null) {
        try {
          localStorage.setItem(LAST_MASTER_DATA_SYNC_KEY, new Date().toISOString())
        } catch {
          // storage full/blocked -- the timestamp is informational only
        }
      }
      dispatch(MasterDataSyncStatusSet('idle'))
    },
    onError: (error: Error) => {
      dispatch(MasterDataSyncStatusSet('failed'))
      toast.error(`Error: ${error?.message ?? 'An error occurred'}`)
    },
  })
}

export default useGetMasterDataStore
